import { render, staticRenderFns } from "./YearlyRentalPriceSqm.vue?vue&type=template&id=23e5cc18&"
import script from "./YearlyRentalPriceSqm.vue?vue&type=script&lang=ts&"
export * from "./YearlyRentalPriceSqm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports